import * as React from 'react';


type Props = {
    t?:any,
    style:any
};

export class HistoryCarArrow extends React.Component<Props,any> {

    public shouldComponentUpdate(nextProps:Props, nextState:any) {
        if(this.props.style && nextProps.style.transform === this.props.style.transform) {
            return false;
        }

        return true;
    }

    public render() {
        return(
            <div className={"historyCarArrow "} style={this.props.style}>
                    <div className="historyCarArrow__face historyCarArrow__face--front" />
                    <div className="historyCarArrow__face historyCarArrow__face--back"/>
                    <div className="historyCarArrow__face historyCarArrow__face--right historyCarArrow__face--long" />
                    <div className="historyCarArrow__face historyCarArrow__face--left historyCarArrow__face--long" />
                    <div className="historyCarArrow__face historyCarArrow__face--top historyCarArrow__face--long" />
                    <div className="historyCarArrow__face historyCarArrow__face--bottom historyCarArrow__face--long" />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/History/HistoryCarArrow.tsx